var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1188,
    height: 872,
    viewBox: "0 0 1188 872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.93 30.16H424.1C467.678 30.16 509.471 47.4712 540.285 78.2853C571.099 109.099 588.41 150.892 588.41 194.47V518.65H240.62V194.47C240.62 150.892 257.931 109.099 288.745 78.2853C319.559 47.4712 361.352 30.16 404.93 30.16V30.16Z",
    fill: "#BEC120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.75 325.63V523.73H323.25V325.63H477.75ZM481.75 321.63H319.25V527.73H481.75V321.63Z",
    fill: "#CA7358"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.75 321.63H319.25V364.24H481.75V321.63Z",
    fill: "#CA7358"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M318.47 218.62V524.72H225.4V218.62H318.47ZM322.47 214.62H221.4V528.72H322.47V214.62Z",
    fill: "#CA7358"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M605.32 156.69V523.69H482.53V156.69H605.32V156.69ZM609.32 152.69H478.53V527.69H609.32V152.69Z",
    fill: "#CA7358"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M531.32 202.73H533.23C537.574 202.73 541.741 204.456 544.812 207.528C547.884 210.599 549.61 214.766 549.61 219.11V257.22H514.94V219.11C514.94 214.766 516.666 210.599 519.738 207.528C522.809 204.456 526.976 202.73 531.32 202.73V202.73Z",
    fill: "#CA7358"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M510.98 232.45H553.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M531.32 300.49H533.23C537.574 300.49 541.741 302.216 544.812 305.288C547.884 308.359 549.61 312.526 549.61 316.87V355H514.94V316.88C514.94 312.536 516.666 308.369 519.738 305.298C522.809 302.226 526.976 300.5 531.32 300.5V300.49Z",
    fill: "#F5EBDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M510.98 330.22H553.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M531.32 398.26H533.23C537.574 398.26 541.741 399.986 544.812 403.058C547.884 406.129 549.61 410.296 549.61 414.64V452.75H514.94V414.64C514.94 410.296 516.666 406.129 519.738 403.058C522.809 399.986 526.976 398.26 531.32 398.26V398.26Z",
    fill: "#F5EBDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M510.98 427.98H553.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M531.32 496H533.23C537.574 496 541.741 497.726 544.812 500.798C547.884 503.869 549.61 508.036 549.61 512.38V547.38H514.94V512.38C514.94 508.036 516.666 503.869 519.738 500.798C522.809 497.726 526.976 496 531.32 496V496Z",
    fill: "#30242A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 283.73H253.23C257.574 283.73 261.741 285.456 264.812 288.528C267.884 291.599 269.61 295.766 269.61 300.11V338.22H234.94V300.11C234.94 295.766 236.666 291.599 239.738 288.528C242.809 285.456 246.976 283.73 251.32 283.73V283.73Z",
    fill: "#F5EBDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M230.98 313.45H273.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 381.49H253.23C257.574 381.49 261.741 383.216 264.812 386.288C267.884 389.359 269.61 393.526 269.61 397.87V436H234.94V397.88C234.939 395.728 235.361 393.597 236.184 391.609C237.007 389.62 238.213 387.813 239.734 386.291C241.255 384.769 243.061 383.562 245.049 382.738C247.037 381.914 249.168 381.49 251.32 381.49V381.49Z",
    fill: "#F5EBDD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230.98 411.22H273.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 479.26H253.23C257.574 479.26 261.741 480.986 264.812 484.058C267.884 487.129 269.61 491.296 269.61 495.64V533.75H234.94V495.64C234.94 491.296 236.666 487.129 239.738 484.058C242.809 480.986 246.976 479.26 251.32 479.26V479.26Z",
    fill: "#CA7358"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.98 508.98H273.58",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M609.32 152.69H478.53V169.04H609.32V152.69Z",
    fill: "#CA7358"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.47 206.69H221.4V223.04H322.47V206.69Z",
    fill: "#CA7358"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M383.16 402.88H348.48V447.47H383.16V402.88Z",
    fill: "#F5EBDD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M344.51 422.7H387.12",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.82 449.45V422.7",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M383.16 483.41H348.48V528H383.16V483.41Z",
    fill: "#CA7358"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344.51 503.22H387.12",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M365.82 529.98V503.22",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M448.55 402.88H413.87V447.47H448.55V402.88Z",
    fill: "#30242A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M409.91 422.7H452.52",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M431.21 449.45V422.7",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M448.55 483.41H413.87V528H448.55V483.41Z",
    fill: "#F5EBDD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M409.91 503.22H452.52",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M431.21 529.98V503.22",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M342.28 151.2C356.507 151.2 368.04 139.667 368.04 125.44C368.04 111.213 356.507 99.68 342.28 99.68C328.053 99.68 316.52 111.213 316.52 125.44C316.52 139.667 328.053 151.2 342.28 151.2Z",
    fill: "#F5EBDD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M633 518.81H196.03V548.54H633V518.81Z",
    fill: "#F5EBDD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M421.42 0.589966H407.61C299 0.589966 210.9 88.67 210.9 197.31V548.54H618.14V197.31C618.14 88.67 530.06 0.589966 421.42 0.589966ZM399.65 518.81H240.65V271.1H399.65V518.81ZM399.65 241.37H240.65V198.32C240.65 155.321 257.136 113.959 286.715 82.751C316.294 51.5426 356.713 32.8635 399.65 30.56V241.37ZM588.41 518.81H429.41V271.1H588.41V518.81ZM588.41 241.37H429.41V30.56C472.347 32.8635 512.766 51.5426 542.345 82.751C571.924 113.959 588.41 155.321 588.41 198.32V241.37Z",
    fill: "#F5EBDD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M519.15 492.7C519.15 492.7 450.49 327.9 447.49 284.94C437.41 140.35 594.27 222.72 618.8 236.94C636.66 247.3 706.7 286.49 720.68 300.46C729.68 309.46 723.42 316.13 723.42 316.13C723.42 316.13 733.93 329.93 719.15 331.57C729.66 345.37 712.9 347.24 712.9 347.24C712.9 347.24 717.39 360.71 699.98 356.66C681.22 352.29 538.98 290.72 538.98 290.72C538.98 290.72 570.76 391.05 580.68 422.79L519.15 492.7Z",
    fill: "#A15842"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M672.48 345.17C675.86 344.5 678.14 342.55 677.48 338.36C675.33 324.6 652.34 311.6 652.34 311.6C652.34 311.6 661.56 289.41 643.46 272.27",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M712.67 346.53C704.42 341.7 674.18 324.01 667.01 320.33",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M719.43 331.12C709.11 324.94 683.97 309.29 673.59 303.85",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M723.18 314.22C710.18 305.6 685.66 289.63 675.96 284.73",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M665.85 318.43C669.31 312.17 675.23 299.73 675.55 279.79",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M538.6 293.06L515.18 282.42",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M181.77 760.68V779.95H348.38V760.68H181.77Z",
    fill: "#A15842"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M375.82 860.65L334.55 613H359.83C362.535 613 365.13 611.925 367.042 610.013C368.955 608.1 370.03 605.505 370.03 602.8C370.03 600.095 368.955 597.5 367.042 595.588C365.13 593.675 362.535 592.6 359.83 592.6H170.56C167.855 592.6 165.26 593.675 163.347 595.588C161.435 597.5 160.36 600.095 160.36 602.8C160.36 605.505 161.435 608.1 163.347 610.013C165.26 611.925 167.855 613 170.56 613H195.56L154.29 860.63C154.08 861.858 154.141 863.118 154.469 864.32C154.797 865.522 155.383 866.639 156.186 867.591C156.99 868.543 157.992 869.309 159.122 869.834C160.253 870.359 161.484 870.63 162.73 870.63V870.63C164.685 870.629 166.58 869.961 168.103 868.735C169.625 867.509 170.683 865.8 171.1 863.89L225.81 613H304.34L359 863.88C359.414 865.79 360.469 867.5 361.99 868.726C363.511 869.953 365.406 870.621 367.36 870.62V870.62C368.605 870.622 369.835 870.353 370.965 869.832C372.096 869.31 373.098 868.548 373.904 867.598C374.709 866.649 375.298 865.536 375.629 864.336C375.96 863.136 376.025 861.878 375.82 860.65V860.65Z",
    fill: "#FFBE21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M359.83 613C362.535 613 365.129 611.925 367.042 610.013C368.955 608.1 370.03 605.505 370.03 602.8C370.03 600.095 368.955 597.5 367.042 595.588C365.129 593.675 362.535 592.6 359.83 592.6H170.56C167.855 592.6 165.26 593.675 163.347 595.588C161.435 597.5 160.36 600.095 160.36 602.8C160.36 605.505 161.435 608.1 163.347 610.013C165.26 611.925 167.855 613 170.56 613H195.56L195.51 613.31H225.7L225.77 613H304.3L304.37 613.31H334.6L334.55 613H359.83Z",
    fill: "#A15842"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M280.94 852.76H45.86L1.53002 716.34C-1.75998 706.22 3.78002 698.02 13.89 698.02H212.34C222.46 698.02 233.34 706.22 236.61 716.34L280.94 852.76Z",
    fill: "#BEC120"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M429 852.76H197.85C198.515 854.81 198.685 856.988 198.346 859.115C198.007 861.243 197.17 863.261 195.902 865.003C194.634 866.745 192.971 868.162 191.05 869.138C189.129 870.115 187.005 870.622 184.85 870.62H416C418.156 870.625 420.281 870.118 422.203 869.143C424.125 868.167 425.789 866.75 427.057 865.007C428.326 863.264 429.163 861.246 429.501 859.117C429.839 856.988 429.667 854.81 429 852.76Z",
    fill: "#BEC120"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M197.85 852.76H46.0898L47.8598 858.22C49.0298 861.823 51.3106 864.964 54.3753 867.192C57.4399 869.419 61.1312 870.619 64.9199 870.62H184.92C187.069 870.611 189.185 870.096 191.097 869.115C193.009 868.134 194.662 866.715 195.922 864.975C197.182 863.234 198.013 861.221 198.348 859.098C198.683 856.976 198.513 854.804 197.85 852.76Z",
    fill: "#CA7358"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M264.92 852.76H63.91L21.96 723.81H222.97L264.92 852.76Z",
    fill: "#F5EBDD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M189.72 827.16H127.8C120.92 827.16 113.54 821.58 111.3 814.71L96.3701 768.71C94.1401 761.84 97.9001 756.26 104.78 756.26H166.7C173.57 756.26 180.95 761.84 183.19 768.71L198.12 814.71C200.35 821.58 196.59 827.16 189.72 827.16Z",
    fill: "#3EC1F3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M47 850.78H279",
    stroke: "#CA7358",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M182.82 766.51L158.4 792.59C153.67 797.59 144.66 797.59 136.65 792.59L96.3301 767.17",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.36 791.83L197.86 816.1",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.92 816.69L134.94 792.1",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M185.19 774.16C177.49 774.16 169.19 767.86 166.65 760.16C165.47 756.52 165.78 753.16 167.53 750.77C169.14 748.57 171.85 747.35 175.17 747.35C182.87 747.35 191.17 753.65 193.7 761.4C194.89 765.04 194.58 768.4 192.82 770.78C191.22 772.94 188.51 774.16 185.19 774.16Z",
    fill: "#4756DF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175.17 749.3C181.95 749.3 189.57 755.1 191.8 761.96C192.8 764.96 192.57 767.68 191.21 769.56C190.488 770.438 189.567 771.132 188.524 771.584C187.48 772.036 186.345 772.233 185.21 772.16C178.42 772.16 170.81 766.36 168.58 759.49C167.58 756.49 167.81 753.78 169.17 751.9C170.39 750.22 172.52 749.3 175.17 749.3ZM175.17 745.3C166.65 745.3 161.98 752.21 164.75 760.73C167.52 769.25 176.67 776.16 185.19 776.16C193.71 776.16 198.38 769.25 195.61 760.73C192.84 752.21 183.69 745.3 175.17 745.3Z",
    fill: "#F5EBDD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M998.09 402.44H997.84C996.06 405.66 984.33 425.35 963.72 425.35C943.11 425.35 931.38 405.66 929.59 402.44H929.35L897.27 547.25H1030.17L998.09 402.44Z",
    fill: "#3EC1F3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M912.47 479.47C939.69 482.32 981.96 506.63 996.65 546.83",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M930.11 548C933.16 515.25 959.11 461.12 1005.81 444.19",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M963.23 414.68C951.76 426.77 937.3 438.03 920.94 445.59",
    stroke: "#F5EBDD",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M963.72 425.35C984.33 425.35 996.06 405.66 997.84 402.44H929.59C931.38 405.66 943.1 425.35 963.72 425.35Z",
    fill: "#30242A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M776.46 870.62C775.07 870.62 773.699 870.291 772.461 869.658C771.223 869.026 770.153 868.109 769.338 866.983C768.523 865.856 767.986 864.553 767.773 863.179C767.56 861.805 767.675 860.4 768.11 859.08L795.69 775.16C796.275 773.409 797.396 771.887 798.895 770.81C800.394 769.733 802.194 769.155 804.04 769.16H823.34C824.874 769.159 826.381 769.558 827.712 770.32C829.043 771.081 830.152 772.177 830.928 773.499C831.705 774.822 832.122 776.324 832.138 777.857C832.154 779.391 831.769 780.902 831.02 782.24L784.14 866.16C783.37 867.517 782.253 868.645 780.903 869.429C779.554 870.212 778.021 870.623 776.46 870.62V870.62Z",
    fill: "#A15842"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.43 870.62C1146.82 870.62 1148.19 870.291 1149.43 869.658C1150.67 869.026 1151.74 868.109 1152.55 866.983C1153.37 865.856 1153.9 864.553 1154.12 863.179C1154.33 861.805 1154.21 860.4 1153.78 859.08L1126.2 775.16C1125.61 773.41 1124.49 771.889 1122.99 770.812C1121.5 769.735 1119.7 769.157 1117.85 769.16H1098.54C1097.01 769.16 1095.5 769.561 1094.17 770.323C1092.84 771.085 1091.73 772.182 1090.96 773.504C1090.18 774.826 1089.77 776.327 1089.75 777.86C1089.74 779.392 1090.12 780.902 1090.87 782.24L1137.75 866.16C1138.52 867.518 1139.64 868.646 1140.99 869.43C1142.34 870.214 1143.87 870.624 1145.43 870.62Z",
    fill: "#A15842"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1188 545.61H735.44V804.69H1188V545.61Z",
    fill: "#BEC120"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.94 579V771.28H769.5V579H1153.94ZM1157.94 575H765.5V775.28H1157.94V575Z",
    fill: "#CA7358"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M961.3 574.64V775.66",
    stroke: "#CA7358",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.78 686.8C1013.21 686.8 1018.43 681.584 1018.43 675.15C1018.43 668.716 1013.21 663.5 1006.78 663.5C1000.35 663.5 995.13 668.716 995.13 675.15C995.13 681.584 1000.35 686.8 1006.78 686.8Z",
    fill: "#30242A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M916.66 686.8C923.094 686.8 928.31 681.584 928.31 675.15C928.31 668.716 923.094 663.5 916.66 663.5C910.226 663.5 905.01 668.716 905.01 675.15C905.01 681.584 910.226 686.8 916.66 686.8Z",
    fill: "#30242A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M294.52 468.2C302.283 468.2 309.728 471.284 315.217 476.773C320.706 482.262 323.79 489.707 323.79 497.47V592.88H265.25V497.47C265.25 489.707 268.334 482.262 273.823 476.773C279.312 471.284 286.757 468.2 294.52 468.2Z",
    fill: "#4756DF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M323.8 505.59H265.25V560.14H323.8V505.59Z",
    fill: "#3EC1F3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M307.53 453.02H281.51V471.45H307.53V453.02Z",
    fill: "#30242A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M652.56 298.28C672.553 298.28 688.76 282.073 688.76 262.08C688.76 242.087 672.553 225.88 652.56 225.88C632.567 225.88 616.36 242.087 616.36 262.08C616.36 282.073 632.567 298.28 652.56 298.28Z",
    fill: "#30242A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M624.45 284.46C627.34 285.77 602.83 228.46 590.55 237.54C579 246.05 609.83 277.81 624.45 284.46Z",
    fill: "#FFBE21"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M621.34 284.35C623.74 287.35 681.59 268.35 673.86 256.57C666.44 245.27 618.94 281.37 621.34 284.35Z",
    fill: "#FFBE21"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M692.24 242.74C705.114 242.74 715.55 232.304 715.55 219.43C715.55 206.556 705.114 196.12 692.24 196.12C679.366 196.12 668.93 206.556 668.93 219.43C668.93 232.304 679.366 242.74 692.24 242.74Z",
    fill: "#30242A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M533.04 632.56H652.07L658.35 602.8H514.93L533.04 632.56Z",
    fill: "#CA7358"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M532 534.36C532 534.36 556.31 502.62 601.93 499.64L632.22 434.57C624.13 433.28 618.3 432.46 618.3 432.46C619.5 429.56 623.58 419.96 628.51 408.12C619.59 402.19 605.02 390.53 601.65 375.82C612.35 374.21 633.65 364.11 625.24 346.44C614.94 324.77 587.68 341.44 587.68 341.44C579.405 332.053 574.119 320.409 572.5 308C569.19 308.34 559.71 307.33 552.98 303.69L552.53 303.43C548.929 310.501 545.698 317.754 542.85 325.16C542.1 327.06 541.38 328.9 540.62 330.65C540.62 330.65 531.21 329.05 529.28 332.94C526.89 337.74 534.05 343.94 534.05 343.94C528.33 354.7 523.26 363.51 525.1 374.67C526.72 384.52 536.01 396.49 557.9 398.49L546.9 433.2L505.9 504.39C513.94 509.1 524.74 518.07 532 534.36Z",
    fill: "#CA7358"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M821.68 395C808.77 378.89 762.68 313.11 747.29 300.77C737.37 292.83 731.42 299.77 731.42 299.77C731.42 299.77 716.54 290.84 716.54 305.72C701.66 296.79 701.66 313.65 701.66 313.65C701.66 313.65 687.77 310.65 693.73 327.54C700.14 345.7 772.09 476.78 772.09 476.78C772.09 476.78 697.69 449.01 668.93 441.61C663.65 440.25 657.18 438.91 650.65 437.69C646.44 447.55 639.86 463.69 629.25 490.69C614.85 527.24 621.85 563.78 663.52 578.28L670.91 543.28C670.91 543.28 747.91 572.22 790.91 571.05C936.74 567.09 839.54 417.31 821.68 395Z",
    fill: "#CA7358"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 308C574.113 320.445 579.414 332.123 587.72 341.53C587.72 341.53 614.98 324.81 625.28 346.53C633.69 364.2 612.39 374.3 601.69 375.91C605.06 390.62 619.63 402.28 628.55 408.21C635.87 390.62 645.05 368.07 649.37 355.21C655.76 336.15 659.06 306.61 630.37 285.27C603.52 265.34 572.75 278.56 565.81 285.5C561.69 289.62 557.81 293.5 552.57 303.5L553.02 303.76C559.71 307.29 569.19 308.3 572.5 308Z",
    fill: "#30242A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M629.25 490.72C639.86 463.78 646.44 447.6 650.65 437.72C644.21 436.51 637.72 435.42 632.26 434.55L602 499.64C556.38 502.64 532.07 534.36 532.07 534.36C524.77 518.07 513.97 509.1 505.98 504.36L496.84 520.23C492.173 528.588 489.806 538.034 489.982 547.605C490.157 557.176 492.869 566.529 497.84 574.71L514.92 602.78H658.35L663.52 578.29C621.85 563.81 614.85 527.27 629.25 490.72Z",
    fill: "#FFBE21"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M558.52 400.54C564.744 400.506 570.933 399.591 576.9 397.82",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M704.53 347.85C705.26 345.31 707.06 343.66 710.59 343.91C724.48 344.91 739.35 366.73 739.35 366.73C739.35 366.73 760.7 355.73 779.29 372.28",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M703.68 313.11C711.44 325.34 725.86 348.11 729.43 353.83",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M718 304.62C726 316.4 740 336.5 745.31 344.91",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M733.66 300C743.66 312.76 758.98 332.56 764.15 341",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M731.42 353.83C737.42 349.83 749.27 342.92 769.11 340.94",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M618.07 430.34L600.49 428.23",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M555.85 622.64L554.86 620.66",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M669.93 545.2L660 541.3",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M794.9 483.77L772.35 474.91",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M658.35 602.8H514.93",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M600.49 499.64L586 532C583.825 536.846 580.296 540.96 575.838 543.846C571.379 546.733 566.181 548.269 560.87 548.27H489.87",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M539.47 356C541.18 357.47 548.12 359.47 551.83 354.46",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M609.93 352.89L597.37 357.76",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M563.08 333.24C562.124 333.479 561.129 333.519 560.156 333.358C559.184 333.197 558.254 332.839 557.426 332.304C556.597 331.77 555.887 331.072 555.339 330.252C554.791 329.433 554.417 328.51 554.24 327.54",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M596.82 370.6L592.28 389.15C592.037 390.11 592.046 391.116 592.307 392.071C592.567 393.026 593.069 393.898 593.765 394.602C594.461 395.306 595.327 395.818 596.279 396.09C597.231 396.361 598.237 396.382 599.2 396.15L616.15 392.15C617.107 391.918 617.988 391.444 618.709 390.773C619.43 390.103 619.967 389.258 620.268 388.321C620.569 387.383 620.624 386.384 620.428 385.419C620.233 384.455 619.792 383.556 619.15 382.81L606.74 368.3C606.055 367.505 605.167 366.913 604.17 366.587C603.173 366.262 602.106 366.214 601.085 366.451C600.063 366.688 599.126 367.2 598.374 367.931C597.622 368.662 597.085 369.585 596.82 370.6V370.6Z",
    fill: "#F4E6D8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M635 801.62C625.08 789.71 590.57 746.62 590.57 746.62",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M903 705C899.36 695.16 892.68 678.67 884.44 658.87L796 684.68L785.86 687.88C790.42 717.37 793.92 731.75 793.92 731.75C793.92 731.75 698.7 644.46 652.08 632.56H533L492.33 870.62H847.43C948.65 870.62 919.88 750.6 903 705Z",
    fill: "#023527"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M806.71 477.49C805.558 474.748 803.492 472.489 800.863 471.098C798.235 469.707 795.205 469.27 792.29 469.86C774.66 473.8 773.29 507.18 769.11 526.42C762.17 558.17 747.29 570.07 746.3 590.9C745.3 610.9 777.05 618.67 777.05 618.67C778.13 629.143 779.227 638.867 780.34 647.84L868.72 621.42C844.48 564.28 815.77 498.27 806.71 477.49Z",
    fill: "#A15842"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M785.81 687.65V687.88L795.95 684.68L785.81 687.65Z",
    fill: "#A15842"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M884.46 658.84C884.2 658.23 883.95 657.61 883.69 656.99L796 684.68L884.46 658.84Z",
    fill: "#3EC1F3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M883.69 657C879.08 645.94 874 633.89 868.69 621.43L780.31 647.85C782.2 663.29 784.07 676.54 785.78 687.66L795.96 684.66L883.69 657Z",
    fill: "#3EC1F3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M615.74 632.25C647.44 665.5 811.36 834.05 862.35 817.05C899.58 804.64 844.76 682.37 839.54 666.28",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M837 767.6C825.51 757.3 805 738.93 794.1 729.23",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M773.08 595.86L775.02 616.59",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M798 471.62L801.76 482.16",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M789 472.62L795.08 487.57",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M558.53 764.84L557.97 764.67L578.66 632.36H533C533 632.36 350.53 702 308.87 768.45C269.49 831.26 341.6 870.62 362.43 870.62H544.1L558.53 764.84Z",
    fill: "#023527"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M750.26 870.62C774.07 870.62 766.14 843.83 749.26 834.91C732.38 825.99 712.56 817.05 691.73 789.28C670.9 761.51 646.1 768.45 630.23 788.28C630.23 788.28 618.13 783.93 600.35 778.03L586.43 870.61L750.26 870.62Z",
    fill: "#CA7358"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M560.27 765.36L558.53 764.84L544.1 870.62H586.44L600.36 778C588.8 774.21 574.85 769.72 560.27 765.36Z",
    fill: "#3EC1F3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M739.35 859.71L754 868.62",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M460.63 741.67C502.29 749.6 520.31 754.67 558 766.67",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M727.45 864.67L736 869.62",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M632.23 787.05L646.11 792.26",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M966.87 413.26C968.99 400.74 978.63 351.08 1002.22 324.21",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.73 367.525C1037.33 358.621 1052.4 347.646 1050.4 343.013C1048.4 338.379 1030.08 341.842 1009.48 350.746C988.883 359.651 973.809 370.625 975.813 375.259C977.816 379.892 996.137 376.43 1016.73 367.525Z",
    fill: "#30242A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.79 237.909C1026.23 227.975 1029.46 217.817 1026 215.22C1022.53 212.622 1013.69 218.57 1006.24 228.503C998.792 238.437 995.563 248.595 999.028 251.192C1002.49 253.79 1011.34 247.843 1018.79 237.909Z",
    fill: "#30242A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1059 304.88C1057.55 300.16 1048.15 298.64 1036.25 300.63C1044.96 288.86 1048.56 277.37 1044.25 273.74C1039.94 270.11 1029.25 275.59 1019.09 286.14C1019.09 274.08 1015.98 265.06 1011.09 264.43C1004.85 263.62 998.01 276.77 995.81 293.79C995.16 298.651 994.98 303.564 995.27 308.46C998.149 307.558 1001.21 307.39 1004.17 307.969C1007.13 308.549 1009.9 309.859 1012.22 311.78C1014.55 313.701 1016.36 316.172 1017.49 318.97C1018.62 321.767 1019.03 324.802 1018.69 327.8C1023.41 327.255 1028.07 326.274 1032.61 324.87C1049 319.85 1060.82 310.9 1059 304.88Z",
    fill: "#FFBE21"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.35 311.9C1010.02 309.932 1007.23 308.584 1004.24 307.983C1001.25 307.381 998.159 307.546 995.25 308.46C995.78 316.57 997.79 322.79 1000.86 325.11C1003.71 327.8 1010.37 328.73 1018.67 327.8C1019.01 324.834 1018.61 321.831 1017.5 319.058C1016.4 316.284 1014.63 313.825 1012.35 311.9V311.9Z",
    fill: "#30242A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M960.33 411.67C959.64 397.45 955.51 327.67 940.03 286.46",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M909.28 371.648C935.879 366.579 956.717 358.661 955.822 353.962C954.926 349.264 932.637 349.565 906.037 354.634C879.437 359.704 858.6 367.622 859.495 372.32C860.391 377.018 882.68 376.718 909.28 371.648Z",
    fill: "#30242A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M951.38 227.12C946.56 226.06 940.63 233.52 936.52 244.86C930.52 231.5 922.28 222.73 917.02 224.69C911.76 226.65 911.25 238.69 915.48 252.69C904.95 246.81 895.59 245.06 892.64 249.02C888.87 254.02 896.97 266.47 910.73 276.74C914.65 279.689 918.842 282.257 923.25 284.41C923.875 281.458 925.228 278.71 927.185 276.413C929.142 274.117 931.641 272.346 934.456 271.26C937.271 270.174 940.313 269.809 943.305 270.196C946.297 270.584 949.145 271.713 951.59 273.48C953.424 269.096 954.853 264.554 955.86 259.91C959.53 243.15 957.53 228.47 951.38 227.12Z",
    fill: "#FFBE21"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M934.64 271.2C931.78 272.263 929.236 274.033 927.245 276.345C925.253 278.656 923.879 281.434 923.25 284.42C930.58 287.93 936.98 289.23 940.51 287.7C944.25 286.52 948.33 281.17 951.59 273.49C949.172 271.741 946.359 270.617 943.402 270.218C940.445 269.818 937.435 270.156 934.64 271.2Z",
    fill: "#30242A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M888.49 301.44V301.5C892.442 303.733 895.413 307.368 896.815 311.686C898.216 316.004 897.947 320.691 896.06 324.82C894.168 328.943 890.801 332.208 886.621 333.972C882.442 335.736 877.754 335.871 873.48 334.35V334.42C895.86 344.65 917.37 345.55 921.48 336.42C925.59 327.29 910.87 311.66 888.49 301.44Z",
    fill: "#FFBE21"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M890.29 331.87C888.359 330.789 886.906 329.02 886.221 326.915C885.536 324.811 885.669 322.526 886.594 320.515C887.518 318.504 889.167 316.916 891.21 316.066C893.254 315.216 895.542 315.168 897.62 315.93C897.395 312.958 896.441 310.087 894.844 307.57C893.246 305.053 891.054 302.969 888.46 301.5L873.46 334.35C876.254 335.347 879.25 335.643 882.185 335.21C885.119 334.778 887.903 333.631 890.29 331.87Z",
    fill: "#F5EBDD"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M886.59 320.54C885.673 322.548 885.544 324.828 886.23 326.927C886.915 329.025 888.364 330.79 890.29 331.87C892.764 330.053 894.734 327.637 896.017 324.848C897.299 322.06 897.851 318.991 897.62 315.93C895.538 315.171 893.248 315.224 891.203 316.078C889.159 316.932 887.512 318.525 886.59 320.54Z",
    fill: "#30242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.f0ede3a0d8eed07e7f7da39d3c4c79ae.svg";
export { ForwardRef as ReactComponent };